<template>
    <select-base
        :model-value="modelValue.variantId"
        @update:model-value="changeVariant"
        class="grey1-grey1-color grey4-grey4-background"
        style="--original-background: var(--ion-color-grey4)"
        :placeholder="$t('placeholder.selectVariant')"
        value-key="variantId"
        :text-key="(option) => { return `${option.item.name} ${option.item.variants.name}` }"
        :options="options"
    >
        {{ $t('modal.selection') }}
    </select-base>
</template>

<script setup lang="ts">
import { SelectVariantProps } from "@/types/props/component";
import { SelectVariantEmits } from "@/types/emits/component";
import SelectBase from "@/components/selects/SelectBase.vue";

const props = defineProps<SelectVariantProps>()
const emit = defineEmits<SelectVariantEmits>()

const changeVariant = (value: string) => {
    const newValue = props.options.find(option => option.variantId === value)

    if (!newValue) return emit('update:modelValue', props.modelValue)

    emit('update:modelValue', newValue)
    emit('change', newValue)
}
</script>

<style scoped>

</style>
